/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ScrollToForm from '../scroll/scrollForm'
import ScrollToContacts from '../scroll/scrollContacts'


const NavigationHandler = ( {children} ) => {
  const navbarRef = useRef(null)
  const navigate = useNavigate()
  const location = useLocation()

  const scrollToFormFunc = ScrollToForm()
  const scrollToContactsFunc = ScrollToContacts()

  const [nav, setNav] = useState(false)
  const scrollTargetIdRef = useRef(null)

  const handleNavLinkClick = (targetPath, targetId) => {
    scrollTargetIdRef.current = targetId
    setNav(false)

    if (targetPath && targetPath !== location.pathname) {
      navigate(targetPath)
    }
    if (targetPath === location.pathname) {
      if (targetId) {
        setTimeout(() => {
          handleScrollToId(targetId)
        }, 0)
      }
    }
  }

  const handleScrollToId = (targetId) => {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth',
      })
    }
  }

  useEffect(() => {
    if (scrollTargetIdRef.current) {
      const targetId = scrollTargetIdRef.current
      scrollTargetIdRef.current = null
      if (location.pathname === '/') {
        setTimeout(() => {
          handleScrollToId(targetId)
        }, 0)
      }
    }
  }, [location.pathname])

  useEffect(() => {
    if (nav) {
      document.body.style.height = '100%'
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
    } else {
      document.body.style.height = ''
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.width = ''
    }
  }, [nav])

  return (
    <>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          handleNavLinkClick,
          nav,
          setNav,
          scrollToFormFunc,
          scrollToContactsFunc,
          navbarRef,
        }),
      )}
    </>
  )
}

export default NavigationHandler
